import { render, staticRenderFns } from "./ApplicantPreview.vue?vue&type=template&id=64128b88&"
import script from "./ApplicantPreview.vue?vue&type=script&lang=js&"
export * from "./ApplicantPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports